const menu = [
  
  {
    heading: "Product Catalog",
  },
  {
    icon: "list-thumb-fill",
    text: "Product Catalog",
    link: "/product-catalogue",
  },
  {
    icon: "upload",
    text: "Bulk update - Product Details",
    link: "/bulk-update",
  },
  
  {
    icon: "upload",
    text: "Bulk update - Color Variant",
    link: "/bulk-update-color-variant",
  },
  
  {
    heading: "Orders",
  },
  {
    icon: "file-docs",
    text: "MTO Purchase Orders",
    link: "/mto-po-listing",
  },
  {
    icon: "file-docs",
    text: "Consignment/Outright PO",
    link: "/consignment-outright-po-listing",
  },
  {
    icon: "file-docs",
    text: "Store PO",
    link: "/store-po-listing",
  },
  {
    icon: "coin-alt",
    text: "Payments",
    link: "/generated-invoice-listing",
  },
  {
    icon: "note-add-c",
    text: "Open Debit Note/Invoice",
    link: "/open-debit-note-listing",
  },  

  {
    heading: "Your Business Overview",
  },
  
  {
    icon: "chart",
    text: "Revenue Report",
    link: "/order-revenue",
  },
  {
    icon: "chart",
    text: "Cancellations And Returns",
    link: "/order-return-cancel",
  },
  
  {
    icon: "chart",
    text: "Delays and Quality Check Report",
    link: "/order-inward",
  },
  
  {
    icon: "chart",
    text: "Consignment Report",
    link: "/purchase-order",
  },
  {
    icon: "chart",
    text: "Most Viewed Products",
    link: "/most-viewed-listing",
  },  
  {
    icon: "chart",
    text: "DSR Report",
    link: "/jewellery-dsr-report",
  },  
  {
    heading: "Help Center",
  },
  {
    icon: "chat-circle",
    text: "Help Center",
    link: "/help-center",
  },
];
export default menu;
